module.exports = __webpack_public_path__ + "img/page-jigyo-top-vanning.bec3733c.jpg";